import React from 'react';
import { useState } from 'react';
import { Button, ButtonProps, Spinner } from 'react-bootstrap';
import { ButtonVariant } from 'react-bootstrap/esm/types';
import './AsyncButton.scss';

interface AsyncButtonProps extends ButtonProps {
    onClickAsync(): Promise<unknown>;
    showSpinnerWhenWaiting?: boolean;
    variant?: ButtonVariant;
    'data-testid'?: string;
}

const AsyncButton: React.FC<AsyncButtonProps> = props => {

    const [isActing, setIsActing] = useState(false);

    async function handleOnClick() {
        setIsActing(true);

        try {
            await props.onClickAsync();
        }
        finally {
            setIsActing(false);
        }
    }

    return <Button className={props.className} onClick={handleOnClick} disabled={props.disabled || isActing} variant={props.variant} data-testid={props['data-testid']}>
        {props.children} {props.showSpinnerWhenWaiting && isActing && <Spinner animation="border" size="sm" className='submit-spinner' />}
    </Button>;
}

export default AsyncButton;